export const environment = {
    apiBaseURL: 'https://bot.game100.gg/api',
    supplierFrontURL: 'https://fc.bazidigital.ir',
};
